import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import PersonIcon from '@material-ui/icons/Person'
import { FlexDataItem } from 'components/FlexDataView'
import Typography from '@material-ui/core/Typography'
import { authorizedLink, humanize } from 'utils'
import StyleSheet from 'styles'
import LockIcon from '@material-ui/icons/Lock'

export class Project extends PureComponent {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  renderDownloadLink = (download) => {
    if (download.documentUrl) {
      return <a href={download.documentUrl} target='_blank' rel="noopener noreferrer">{download.name}</a>
    } else {
      return <a href={authorizedLink(download.attachmentUrl)}>{download.attachmentFileName}</a>
    }
  }

  render = () => {
    const {dealSheet} = this.props
    const isEquity = dealSheet.typeOfIssuance === 'equity'
    return (
      <FlexDataItem>
        <Typography variant='subtitle1'><PersonIcon />Project</Typography>
        <dl>
          <dt>Name</dt>
          <dd>{dealSheet.name}&nbsp;</dd>
          {!isEquity &&
          <Fragment>
            <dt>Ticker</dt>
            <dd>{dealSheet.ticker}</dd>
            <dt>Long-form</dt>
            <dd>{dealSheet.tickerLongForm}</dd>
            <dt>Short-form</dt>
            <dd>{dealSheet.tickerShortForm}</dd>
          </Fragment>
          }
          <dt>Issuers legal entity</dt>
          <dd>{dealSheet.companyInfo.legalName}</dd>
          <dt>Website</dt>
          <dd>{dealSheet.tokenSaleWebsite}</dd>
          <dt>Deal Type</dt>
          <dd>{humanize(dealSheet.typeOfIssuance)}</dd>
          {!isEquity &&
          <Fragment>
            <dt>Token Type</dt>
            <dd>{dealSheet.tokenType}</dd>
            <dt>Total supply</dt>
            <dd>{dealSheet.preSaleTokenAmount} {dealSheet.ticker}</dd>
          </Fragment>
          }
          <dt>Documents</dt>
          <dd>
            <ul className={styles.downloads}>
              {dealSheet.downloads.map(download =>
                <li key={download.id}>
                  {this.renderDownloadLink(download)}
                  {download.isPrivate && <LockIcon/>}
                </li>
              )}
            </ul>
          </dd>
        </dl>
      </FlexDataItem>
    )
  }
}

const styles = StyleSheet({
  downloads: {
    '& li a': {
      color: '#6AAEAA',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      }
    },
    '& li svg': {
      margin: [-4, 0],
      fontSize: '1.5em'
    }
  }
})